import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
  URL_PARTNER_SCOPED,
  URL_PUBLIC,
} from '@retailer-platform/dashboard/routing'

// Merchandising Routes
const URL_MERCHANDISING = `${URL_RETAILER_SCOPED}/merchandising`
const URL_MERCHANDISING_HERO_BANNERS = `${URL_MERCHANDISING}/hero-banners`
const URL_MERCHANDISING_HERO_BANNERS_LIST = `${URL_MERCHANDISING}/hero-banners/list`
const URL_MERCHANDISING_HERO_BANNERS_EDIT = `${URL_MERCHANDISING}/hero-banners/edit/:heroBannerId`
const URL_MERCHANDISING_HERO_BANNERS_DETAILS = `${URL_MERCHANDISING}/hero-banners/details/:heroBannerId`
const URL_MERCHANDISING_HERO_BANNERS_CREATE = `${URL_MERCHANDISING}/hero-banners/create`
// Partner-scoped multi-retailer hero-banners dashboard (no /warehouses/:warehouse_id — spans every
// authorized retailer under the partner; retailer(s) chosen via in-page picker, list persists via URL).
const URL_MERCHANDISING_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/merchandising`
const URL_MERCHANDISING_HERO_BANNERS_DASHBOARD = `${URL_MERCHANDISING_PARTNER_SCOPED}/hero-banners/dashboard`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'merchandising'>
  | DashRouteType<'merchandising-partner-scoped'>
  | DashRouteType<'merchandising-hero-banners'>
  | DashRouteType<'merchandising-hero-banners-list'>
  | DashRouteType<'merchandising-hero-banners-dashboard'>
  | DashRouteType<'merchandising-hero-banners-details'>
  | DashRouteType<'merchandising-hero-banners-edit'>
  | DashRouteType<'merchandising-hero-banners-create'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  merchandising: URL_MERCHANDISING,
  'merchandising-partner-scoped': URL_MERCHANDISING_PARTNER_SCOPED,
  'merchandising-hero-banners': URL_MERCHANDISING_HERO_BANNERS,
  'merchandising-hero-banners-list': URL_MERCHANDISING_HERO_BANNERS_LIST,
  'merchandising-hero-banners-dashboard': URL_MERCHANDISING_HERO_BANNERS_DASHBOARD,
  'merchandising-hero-banners-details': URL_MERCHANDISING_HERO_BANNERS_DETAILS,
  'merchandising-hero-banners-edit': URL_MERCHANDISING_HERO_BANNERS_EDIT,
  'merchandising-hero-banners-create': URL_MERCHANDISING_HERO_BANNERS_CREATE,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
